module.exports = __webpack_public_path__ + "img/cs-2.6b932c0f.jpg";